// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-modules-project-components-MediaLibraryButton---wrapper---2m5n7","open":"src-modules-project-components-MediaLibraryButton---open---1bE8A"};